export const gameToken = `${import.meta.env.VITE_GAME_TOKEN}`
